export const limitedPropertiesList =
  process.env["REACT_APP_DASH_ENV"] === "development" ||
  process.env["REACT_APP_DASH_ENV"] === "beta"
    ? [
        "67bd1a04bfe22987a89fd78a",
        "67bcf2f5988812f5807528c6",
        "67bd0933988812f5807575ac",
        "645255837d50a08866a5f0d1",
        "67bcec13988812f5807508f0",
        "67b6bb010c5a2244a8557159",
        "67b8de5fe3eb3ee6919ba598",
        "67bcce04988812f580748d93",
        "67b91daff84826155c60c0c7",
        "67b8fd91f84826155c5fd7a7",
        "645255837d50a08866a5f180",
        "67b902fff84826155c6011a3",
        "67b8eecaf84826155c5f89b0",
        "67b8e436e3eb3ee6919bbc69",
        "67b8d90ae3eb3ee6919b8e60",
      ]
    : [
        "6492349529185dc38b5f8443",
        "64812ec74d145ee2c18012fd",
        "65427a0838d3acf37669032c",
        "662f9c1829421f4d3c80e365",
        "6603345e9e14ae0b0115940a",
        "65ef1c85ee147089cb7c00c7",
        "65f3108b398a455954b7529c",
        "645255837d50a08866a5f1b7",
        "645fdb1a7baeec692e2d4b66",
        "6807f1f67d98107eafc8dc0a",
        "65bd7d9d8544873d37688558",
        "64a8467ad437de0333fce201",
        "65a44932cc7fc210231a7072",
        "655e31e2e324c49ff522358e",
        "64f698925cf1c8aecfc855a5",
      ];

export const isPropertyAccessFree = (propertyId: string) => {
  return limitedPropertiesList.includes(propertyId);
};
